import { useAuth } from "../context/AuthContext";
import { Hourglass, ArrowRight, X } from "@phosphor-icons/react";
import { useState } from "react";

/**
 * Banner oberhalb des Dashboards bei aktivem Trial.
 * Zeigt verbleibende Tage + CTA „Jetzt aktivieren".
 * Letzten 2 Tage warnt visuell stärker.
 */
export default function TrialBanner() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(false);

  if (!user) return null;
  // Superadmin sieht das nie
  if (user.is_superadmin) return null;
  if (!user.is_trial || user.trial_expired) return null;
  if (hidden) return null;

  const days = user.trial_days_remaining ?? 0;
  const isUrgent = days <= 2;
  const isCritical = days === 0;

  const bg = isCritical
    ? "bg-red-50 border-red-300 text-red-900"
    : isUrgent
    ? "bg-amber-50 border-amber-300 text-amber-900"
    : "bg-[#002FA7]/5 border-[#002FA7]/30 text-zinc-800";

  const accent = isCritical
    ? "bg-red-600"
    : isUrgent
    ? "bg-amber-600"
    : "bg-[#002FA7]";

  const upgradeMail = `mailto:vahits@icloud.com?subject=NutriCalc%20Plan%20aktivieren%20-%20${encodeURIComponent(user?.company_name || "")}&body=${encodeURIComponent(
    `Hallo Vahit,\n\nich möchte den Team-Plan für meine Firma „${user?.company_name}" aktivieren.\n\nMeine Daten:\n- Firma: ${user?.company_name}\n- E-Mail: ${user?.email}\n- Name: ${user?.full_name}\n\nViele Grüße`
  )}`;

  return (
    <div className={`flex items-center gap-3 ${bg} border rounded-sm px-4 py-2.5 mb-5`}
      data-testid="trial-banner">
      <div className={`w-7 h-7 rounded-sm ${accent} text-white flex items-center justify-center flex-shrink-0`}>
        <Hourglass size={14} weight="fill" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-sm leading-tight">
          {isCritical
            ? "Letzter Tag der Testphase!"
            : days === 1
            ? "Noch 1 Tag in deiner Testphase"
            : `Noch ${days} Tage in deiner kostenlosen Testphase`}
        </div>
        <div className="text-xs opacity-80 mt-0.5">
          Aktiviere den Team-Plan (149 € / Monat für 5 Nutzer) jetzt — keine Unterbrechung, keine Datenverluste.
        </div>
      </div>
      <a href={upgradeMail}
        className={`hidden sm:inline-flex items-center gap-1.5 ${accent} text-white text-xs font-bold px-3 py-1.5 rounded-sm hover:opacity-90 transition-opacity`}
        data-testid="trial-banner-upgrade">
        Jetzt aktivieren <ArrowRight size={12} weight="bold" />
      </a>
      {!isCritical && (
        <button onClick={() => setHidden(true)}
          className="opacity-50 hover:opacity-100 p-1 rounded-sm"
          aria-label="Banner ausblenden"
          data-testid="trial-banner-dismiss">
          <X size={14} weight="bold" />
        </button>
      )}
    </div>
  );
}
